export const isValidProjectYear = value => /^[1-9]\d{3}$/.test(String(value ?? ''));

export const withProjectYearUpdate = payload => {
  if (!isValidProjectYear(payload.year)) {
    throw new Error('분류 연도는 1000~9999 사이의 네 자리 숫자로 입력해주세요.');
  }
  return { ...payload, year: Number(payload.year) };
};
